import { z } from 'zod'

export const RunnoCreateSchema = z.object({
  key: z.string(),
  machine: z.string().optional(),
  year: z.number(),
  month: z.number().optional(),
  prefix: z.string(),
  currentNumber: z.number(),
  padding: z.number(),
  suffix: z.string(),
})

export type RunnoCreateModel = z.infer<typeof RunnoCreateSchema>

export const RunnoUpdateSchema = z.object({
  id: z.number(),
  key: z.string(),
  machine: z.string().optional(),
  year: z.number(),
  month: z.number().nullish(),
  prefix: z.string(),
  currentNumber: z.number(),
  padding: z.number(),
  suffix: z.string(),
})

export type RunnoUpdateModel = z.infer<typeof RunnoUpdateSchema>
